import { ActionRequest } from './BaseActionModel';

export enum UserAction {
	BANNER_VIEW = 'banner_view',
	BANNER_CLICK = 'banner_click',
}

export type BannerAction = UserAction.BANNER_VIEW
	| UserAction.BANNER_CLICK;

export enum BannerLocation {
	EVENT_PAGE_WELCOME = 'event_page_welcome',
	EVENT_PAGE_MAIN = 'event_page_main',
	MY_EVENTS_LIST = 'my_events_list',
	GROUP_EVENTS_LIST = 'group_events_list',
	GROUP_MAIN_UPCOMING_EVENTS = 'group_main_upcoming_events',
	GROUP_MAIN_NEXT_EVENT = 'group_main_next_event',
	UNKNOWN = 'unknown',
}

export interface BannerActionMetadata {
	location: BannerLocation;
	pageUrl: string;
	// Hashed group ID
	groupId?: string;
}

export type BannerClickActionRequest = ActionRequest<UserAction.BANNER_CLICK, BannerActionMetadata>;
export type BannerViewActionRequest = ActionRequest<UserAction.BANNER_VIEW, BannerActionMetadata>;

export type UserActionRequest = BannerClickActionRequest
	| BannerViewActionRequest;
